import { get } from "lodash";
import { CartUpsellingToolInput, Package } from "./types";

export function getTranslation(key: string, locale?: string) {
  //@ts-ignore
  if (!window.rxcTranslations?.[locale || "en_US"]) return;
  //@ts-ignore
  return get(window.rxcTranslations?.[locale || "en_US"], key);
}
//funzioni utili per valorizzare URLs

const getReviewConfig = (suggestion, input, content) => {
  let config = {};
  config.typeConfig =
    input?._config?.rxType ||
    input._content?.type?.[suggestion.lensPackage.type] ||
    content?.type?.[suggestion.lensPackage?.type];
  config.brandConfig =
    input._content?.brand?.[suggestion.lensPackage.brand] ||
    content?.brand?.[suggestion.lensPackage?.brand];
  config.colorConfig =
    input._content?.color?.[suggestion.lensPackage.color] ||
    content?.color?.[suggestion.lensPackage?.color];
  config.thicknessConfig =
    input._content?.thickness?.[suggestion.lensPackage.thickness] ||
    content?.thickness?.[suggestion.lensPackage?.thickness];
  config.antiReflectiveConfig =
    input._content?.antiReflective?.[suggestion.lensPackage.antiReflective] ||
    content?.antiReflective?.[suggestion.lensPackage.antiReflective];
  config.blueLigthConfig =
    input._content?.blueLight?.[suggestion.lensPackage.blueLight] ||
    content?.blueLight?.[suggestion.lensPackage.blueLight];
  config.transitionConfig =
    input._content?.transition?.[suggestion.lensPackage.transition] ||
    content?.transition?.[suggestion.lensPackage.transition];
  config.antiFogConfig =
    input._content?.antiFog?.[
      suggestion.lensPackage.antiFog === false ? "False" : "True"
    ] ||
    content?.antiFog?.[
      suggestion.lensPackage.antiFog === false ? "False" : "True"
    ];
  config.treatmentFamilyConfig =
    input._content?.treatmentFamily?.[suggestion?.lensPackage?.treatmentFamily];
  return config;
};

const getMapReview = (config, suggestion, input) => {
  const review = [];

  const {
    typeConfig,
    brandConfig,
    blueLigthConfig,
    transitionConfig,
    colorConfig,
    thicknessConfig,
    antiReflectiveConfig,
    antiFogConfig,
    treatmentFamilyConfig,
  } = config;

  typeConfig &&
    review.push({
      Type: {
        name:
          getTranslation("steps.type.confirmedTitle", input._locale) ||
          "Vision need:",
        description: input?._config?.rxType
          ? input?._config?.rxType
          : typeConfig.title
            ? typeConfig.title
            : "",
      },
    });

  brandConfig &&
    review.push({
      Brand: {
        name:
          getTranslation("steps.brand.confirmedTitle", input._locale) ||
          "Lens brand:",
        description: brandConfig.title || "",
      },
    });

  if (treatmentFamilyConfig) {
    review.push({
      TreatmentsFamily: {
        name:
          getTranslation(
            "steps.treatmentsFamily.confirmedTitle",
            input._locale,
          ) || "Lens type:",
        description: treatmentFamilyConfig?.title
          ? treatmentFamilyConfig?.title
          : "",
      },
    });
  }

  if (transitionConfig) {
    review.push({
      TreatmentsFamily: {
        name:
          getTranslation("steps.treatment.confirmedTitle", input._locale) ||
          "Lens type:",
        description: transitionConfig?.title ? transitionConfig?.title : "",
      },
    });
  }
  if (blueLigthConfig) {
    review.push({
      BlueLight: {
        name:
          getTranslation("steps.blueLight.confirmedTitle", input._locale) ||
          "Lens type:",
        description: blueLigthConfig.title ? blueLigthConfig.title : "",
      },
    });
  }

  colorConfig &&
    review.push({
      TransitionColor: {
        name:
          getTranslation(
            "steps.transitionColor.confirmedTitle",
            input._locale,
          ) || "Color:",
        description: colorConfig.title,
      },
    });

  /* designTypeConfig &&
    review.push({
      DesignType: {
        name:
          getTranslation("steps.type.confirmedTitle", input._locale) ||
          "Design type:",
        description: designTypeConfig.title,
      },
    }); */

  thicknessConfig &&
    review.push({
      Thickness: {
        name:
          getTranslation("steps.thickness.confirmedTitle", input._locale) ||
          "Thickness:",
        description: thicknessConfig.title,
      },
    });
  antiFogConfig &&
    review.push({
      antiFog: {
        name:
          getTranslation("steps.antiFog.confirmedTitle", input._locale) ||
          "AntiFog:",
        description: antiFogConfig.title,
      },
    });
  const addOns = [];
  antiReflectiveConfig && addOns.push(antiReflectiveConfig.title);
  suggestion.lensPackage.antiScratch && addOns.push("Scratch resistant");
  suggestion.lensPackage.uvProtection && addOns.push("UV Protection");

  blueLigthConfig && transitionConfig
    ? addOns.push(blueLigthConfig.title)
    : null;

  addOns.length > 0 &&
    review.push({
      AddOns: {
        name:
          getTranslation("steps.addOns.confirmedTitle", input._locale) ||
          "Finishings",
        children: addOns.map((addOn, i) => ({ name: addOn, sequence: i + 1 })),
      },
    });
  return review;
};

export const getReview = async (
  suggestion: Package,
  input: {
    _content: CartUpsellingToolInput["_content"];
    _locale: CartUpsellingToolInput["_locale"];
    _packages: CartUpsellingToolInput["_packages"];
    _currentPackage: CartUpsellingToolInput["_currentPackage"];
    _imagery: CartUpsellingToolInput["_imagery"];
  },
): Promise<any> => {
  try {
    const config = getReviewConfig(suggestion, input, {
      ...input._content,
      ...input._packages,
    });
    console.log("config review", config);
    if (Object.keys(config).length > 0) {
      const review = getMapReview(config, suggestion, input);
      console.log("config review mapped", config);
      const reviewMapped = review
        .map((el, i) => {
          const key = Object.keys(el)?.[0];
          if (key) return { [key]: { ...el[key], sequence: i + 1 } };
        })
        .reduce((acc, el, i) => {
          return { ...acc, ...el };
        }, {});
      return reviewMapped;
    }
  } catch (error) {
    console.log("Error in getReview:", error);
    return {};
  }
};
